enum PaymentStatus {
    Pending, Complete, Failed, Cancelled, Queued, FailedAndRetried
}

export {PaymentStatus};